import { render } from "./StatusPercentage.vue?vue&type=template&id=797355bc&scoped=true"
import script from "./StatusPercentage.vue?vue&type=script&lang=js"
export * from "./StatusPercentage.vue?vue&type=script&lang=js"

import "./StatusPercentage.vue?vue&type=style&index=0&id=797355bc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797355bc"]])

export default __exports__